import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Alert, AlertTitle, Avatar, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, ListItem, ListItemAvatar, ListItemText } from "@mui/material";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { limpiarAdjuntos } from '../../Redux/ghResponde';
import TokenContext from '../../context/TokenContext';
import useGetAdjuntos from '../hooks/useGetAdjuntos';
import { FileDownload } from '@mui/icons-material';

const ModalAdjuntos = ({ open, handleClose, id }) => {
    const token = useContext(TokenContext)
    const dispatch = useDispatch()

    const { adjuntos, loadingAdjuntosSelector, setAdjuntos } = useGetAdjuntos(token, id)

    const cerrarYlimpiar = () => {
        dispatch(limpiarAdjuntos());
        setAdjuntos([])
        handleClose(false)
    }
    
    const downloadBase64File = (contentType, base64Data, fileName) => {
        if (contentType && base64Data && fileName) {
            const linkSource = `data:${contentType};base64,${base64Data}`;
            const downloadLink = document.createElement("a");
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
        }
    };

    return (
        <Dialog
            open={open}
            onClose={() => cerrarYlimpiar()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth='sm'
            fullWidth={true}
        >
            <DialogTitle>Adjuntos</DialogTitle>
            <DialogContent>
                {
                    loadingAdjuntosSelector ? (
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                height: '100%',
                                py: 2
                            }}>
                            <CircularProgress color="secondary" />
                        </Box>
                    ) :
                        adjuntos.length > 0 ? (
                            <>
                                {adjuntos.map((adjunto) => (
                                    <ListItem key={adjunto.id}>
                                        <ListItemAvatar>
                                            <Avatar>
                                            <IconButton>
                                                <FileDownload onClick={() => downloadBase64File(adjunto.mimetype, adjunto.documentbody, adjunto.filename)} />
                                            </IconButton>
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={adjunto.filename}
                                            secondary={`Tipo de archivo: ${adjunto.mimetype}`}
                                        />
                                    </ListItem>
                                ))}
                            </>
                        ) :
                            <Alert severity="info">
                                <AlertTitle>Info</AlertTitle>
                                No existen registros de — <strong>Adjuntos</strong>.
                            </Alert>
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={() => cerrarYlimpiar()} color="secondary" variant="contained">
                    Cerrar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ModalAdjuntos